import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-10 text-center text-gray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm"
}
const _hoisted_3 = {
  key: 2,
  class: "space-y-4 text-sm"
}
const _hoisted_4 = { class: "rounded-lg border border-indigo-200 bg-indigo-50 p-3" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 text-gray-700" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "mt-3 flex flex-wrap gap-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 text-gray-700" }
const _hoisted_11 = { class: "font-mono text-xs" }
const _hoisted_12 = { class: "break-all" }
const _hoisted_13 = {
  key: 0,
  class: "ml-2 text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "space-y-3" }
const _hoisted_20 = {
  key: 0,
  class: "rounded-lg border border-gray-200 p-3 bg-gray-50"
}
const _hoisted_21 = { class: "text-xs font-medium text-gray-500 uppercase tracking-wide mb-1" }
const _hoisted_22 = {
  key: 0,
  class: "normal-case"
}
const _hoisted_23 = { class: "text-gray-800 whitespace-pre-line" }
const _hoisted_24 = {
  key: 1,
  class: "rounded-lg border border-gray-200 p-3 bg-gray-50"
}
const _hoisted_25 = { class: "text-xs font-medium text-gray-500 uppercase tracking-wide mb-1" }
const _hoisted_26 = {
  key: 0,
  class: "normal-case"
}
const _hoisted_27 = { class: "text-gray-800 whitespace-pre-line" }
const _hoisted_28 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 text-gray-700" }
const _hoisted_29 = { class: "flex items-center flex-wrap gap-2 break-all" }
const _hoisted_30 = {
  key: 0,
  href: "https://ec.europa.eu/taxation_customs/vies/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "inline-flex items-center gap-1 text-xs text-indigo-600 hover:text-indigo-800 hover:underline"
}
const _hoisted_31 = { class: "break-all" }
const _hoisted_32 = {
  key: 1,
  class: "rounded-lg border border-red-200 bg-red-50 p-3"
}
const _hoisted_33 = { class: "font-semibold text-red-900 mb-2" }
const _hoisted_34 = { class: "space-y-2" }
const _hoisted_35 = { class: "font-medium" }
const _hoisted_36 = { class: "text-xs text-red-700 font-mono" }
const _hoisted_37 = {
  key: 0,
  class: "text-xs text-red-600"
}
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "grid grid-cols-2 gap-x-4 gap-y-1 text-gray-700" }
const _hoisted_40 = { class: "break-all" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "col-span-1 whitespace-pre-wrap break-words" }
const _hoisted_43 = { class: "flex justify-end pt-2" }

import { ref, watch } from 'vue'
import { ModalComp } from '@/components'
import { useAdminEfpStore } from '@/stores/adminEfp'
import type { AdminEfpAcheteurAdresse, AdminEfpAcheteurDetails } from '@/api/adminEfp'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminAcheteurDetailsModal',
  setup(__props, { expose: __expose }) {

const adminEfp = useAdminEfpStore()

const modalVisible = ref(false)
const details = ref<AdminEfpAcheteurDetails | null>(null)
const detailsLoading = ref(false)
const detailsError = ref('')
const customerUrlLoading = ref(false)

async function open(idAcheteur: number) {
  modalVisible.value = true
  details.value = null
  detailsError.value = ''
  detailsLoading.value = true
  try {
    details.value = await adminEfp.getAcheteurDetails(idAcheteur)
  } catch (e) {
    detailsError.value = e instanceof Error ? e.message : 'Erreur de chargement'
  } finally {
    detailsLoading.value = false
  }
}

function onModalVisibilityChange(visible: boolean) {
  modalVisible.value = visible
}

function formatDate(d: string | null | undefined): string {
  if (!d) return '—'
  const dt = new Date(d)
  if (Number.isNaN(dt.getTime())) return String(d)
  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium' }).format(dt)
}

function formatSiteUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) return url
  return `https://${url}`
}

function formatPrice(n: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n)
}

async function openCustomerPage(id: number | string) {
  if (customerUrlLoading.value) return
  customerUrlLoading.value = true
  const win = window.open('', '_blank')
  try {
    const url = await adminEfp.getCustomerAuthUrl(Number(id))
    if (win) {
      win.opener = null
      win.location.href = url
    } else {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  } catch (e) {
    if (win) win.close()
    detailsError.value =
      e instanceof Error ? e.message : 'Erreur ouverture page client'
  } finally {
    customerUrlLoading.value = false
  }
}

function formatAdresseBlock(adr: AdminEfpAcheteurAdresse): string {
  const lines: string[] = []
  if (adr.societe) lines.push(adr.societe)
  if (adr.contact) lines.push(adr.contact)
  if (adr.ligneAdresse) lines.push(adr.ligneAdresse)
  const cpVille = [adr.codePostal, adr.ville].filter(Boolean).join(' ')
  if (cpVille) lines.push(cpVille)
  if (adr.pays) lines.push(adr.pays)
  const phones = [adr.telephone, adr.mobile].filter(Boolean)
  if (phones.length) lines.push(phones.join(' · '))
  return lines.length ? lines.join('\n') : '—'
}

watch(modalVisible, (visible) => {
  if (!visible) {
    details.value = null
    detailsError.value = ''
  }
})

__expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(ModalComp), {
    "is-visible": modalVisible.value,
    title: "Fiche acheteur",
    size: "lg",
    "hide-footer": "",
    "onUpdate:isVisible": onModalVisibilityChange
  }, {
    body: _withCtx(() => [
      (detailsLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl mb-3" }, null, -1),
            _createElementVNode("p", null, "Chargement…", -1)
          ])))
        : (detailsError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(detailsError.value), 1))
          : (details.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("section", _hoisted_4, [
                  _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "font-semibold text-indigo-900 mb-2" }, "Activité commandes", -1)),
                  _createElementVNode("dl", _hoisted_5, [
                    _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "text-gray-500" }, "Nombre de commandes", -1)),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(details.value.nbCommandes), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "text-gray-500" }, "Dernière commande", -1)),
                    _createElementVNode("dd", null, _toDisplayString(details.value.derniereCommande ? formatDate(details.value.derniereCommande) : '—'), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "text-gray-500" }, "CA total", -1)),
                    _createElementVNode("dd", _hoisted_7, _toDisplayString(formatPrice(details.value.caTotal)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'adminEFP/orders',
                query: { acheteur_id: String(details.value.id_acheteur) },
              },
                      class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (modalVisible.value = false))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1),
                        _createTextVNode(" Voir ses commandes ")
                      ])),
                      _: 1,
                      __: [7]
                    }, 8, ["to"]),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: customerUrlLoading.value,
                      class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg border border-indigo-200 bg-white text-indigo-700 hover:bg-indigo-50 transition-colors disabled:opacity-50",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openCustomerPage(details.value.id_acheteur)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(customerUrlLoading.value ? 'fas fa-spinner fa-spin' : 'fas fa-external-link-alt')
                      }, null, 2),
                      _cache[8] || (_cache[8] = _createTextVNode(" Voir la page client "))
                    ], 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("section", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-2" }, "Identité", -1)),
                  _createElementVNode("dl", _hoisted_10, [
                    _cache[10] || (_cache[10] = _createElementVNode("dt", { class: "text-gray-500" }, "ID acheteur", -1)),
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(details.value.id_acheteur), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("dt", { class: "text-gray-500" }, "Société", -1)),
                    _createElementVNode("dd", null, _toDisplayString(details.value.nomSociete || '—'), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("dt", { class: "text-gray-500" }, "Contact", -1)),
                    _createElementVNode("dd", null, _toDisplayString([details.value.prenomContact, details.value.nomContact].filter(Boolean).join(' ') || '—'), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("dt", { class: "text-gray-500" }, "Email", -1)),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(details.value.email || '—'), 1),
                    _cache[14] || (_cache[14] = _createElementVNode("dt", { class: "text-gray-500" }, "Statut eFashion", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(
                  details.value.statutEfashion === 'Actif' ||
                  details.value.statutEfashion === 'Validé'
                    ? 'text-green-700 font-medium'
                    : 'text-amber-700 font-medium'
                )
                      }, _toDisplayString(details.value.statutEfashion), 3)
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("dt", { class: "text-gray-500" }, "Statut compte", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass([details.value.statut === 1 ? 'text-green-700' : 'text-amber-700', "font-medium"])
                      }, _toDisplayString(details.value.statutCompte), 3),
                      (details.value.in_tmp)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Nouveau compte — validation en attente "))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("dt", { class: "text-gray-500" }, "Date création", -1)),
                    _createElementVNode("dd", null, _toDisplayString(formatDate(details.value.dateCreation)), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("dt", { class: "text-gray-500" }, "Téléphone fixe", -1)),
                    _createElementVNode("dd", null, [
                      (details.value.telephone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `tel:${details.value.telephone}`,
                            class: "text-indigo-600 hover:underline"
                          }, _toDisplayString(details.value.telephone), 9, _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("dt", { class: "text-gray-500" }, "Mobile", -1)),
                    _createElementVNode("dd", null, [
                      (details.value.mobile)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `tel:${details.value.mobile}`,
                            class: "text-indigo-600 hover:underline"
                          }, _toDisplayString(details.value.mobile), 9, _hoisted_16))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
                    ])
                  ])
                ]),
                (details.value.adresseLivraison || details.value.adresseFacturation)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                      _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-2" }, "Adresses", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        (details.value.adresseLivraison)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("p", _hoisted_21, [
                                _cache[20] || (_cache[20] = _createTextVNode(" Livraison ")),
                                (details.value.adresseLivraison.typeLibelle)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " — " + _toDisplayString(details.value.adresseLivraison.typeLibelle), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_23, _toDisplayString(formatAdresseBlock(details.value.adresseLivraison)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (details.value.adresseFacturation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("p", _hoisted_25, [
                                _cache[21] || (_cache[21] = _createTextVNode(" Facturation ")),
                                (details.value.adresseFacturation.typeLibelle)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, " — " + _toDisplayString(details.value.adresseFacturation.typeLibelle), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_27, _toDisplayString(formatAdresseBlock(details.value.adresseFacturation)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", null, [
                  _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-2" }, "Fiscal & international", -1)),
                  _createElementVNode("dl", _hoisted_28, [
                    _cache[24] || (_cache[24] = _createElementVNode("dt", { class: "text-gray-500" }, "Régime TVA", -1)),
                    _createElementVNode("dd", {
                      class: _normalizeClass(details.value.active_tva === 1 ? 'text-green-700' : 'text-amber-700')
                    }, _toDisplayString(details.value.regimeTva), 3),
                    _cache[25] || (_cache[25] = _createElementVNode("dt", { class: "text-gray-500" }, "SIRET / TVA intra", -1)),
                    _createElementVNode("dd", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(details.value.tva_intra || '—'), 1),
                      (details.value.tva_intra)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_30, _cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1),
                            _createTextVNode(" VIES ")
                          ])))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("dt", { class: "text-gray-500" }, "EORI", -1)),
                    _createElementVNode("dd", _hoisted_31, _toDisplayString(details.value.eori || '—'), 1),
                    _cache[27] || (_cache[27] = _createElementVNode("dt", { class: "text-gray-500" }, "Pays", -1)),
                    _createElementVNode("dd", null, _toDisplayString(details.value.pays || '—'), 1),
                    _cache[28] || (_cache[28] = _createElementVNode("dt", { class: "text-gray-500" }, "Langue", -1)),
                    _createElementVNode("dd", null, _toDisplayString(details.value.LangueDefaut || '—'), 1)
                  ])
                ]),
                (details.value.vendeursBloqueurs.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                      _createElementVNode("h4", _hoisted_33, [
                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-ban mr-1 text-red-500" }, null, -1)),
                        _createTextVNode(" Bloqué par " + _toDisplayString(details.value.vendeursBloqueurs.length) + " vendeur(s) ", 1)
                      ]),
                      _createElementVNode("ul", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value.vendeursBloqueurs, (v) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: v.id_vendeur,
                            class: "text-sm text-red-900 flex flex-wrap items-baseline gap-x-2"
                          }, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(v.vendeurLabel), 1),
                            _createElementVNode("span", _hoisted_36, "#" + _toDisplayString(v.id_vendeur), 1),
                            (v.dateDisabled)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, " · " + _toDisplayString(formatDate(v.dateDisabled)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (details.value.site_web || details.value.commentaires)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                      _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "font-semibold text-gray-900 mb-2" }, "Compléments", -1)),
                      _createElementVNode("dl", _hoisted_39, [
                        (details.value.site_web)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[31] || (_cache[31] = _createElementVNode("dt", { class: "text-gray-500" }, "Site web", -1)),
                              _createElementVNode("dd", _hoisted_40, [
                                _createElementVNode("a", {
                                  href: formatSiteUrl(details.value.site_web),
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "text-indigo-600 hover:underline"
                                }, _toDisplayString(details.value.site_web), 9, _hoisted_41)
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (details.value.commentaires)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[32] || (_cache[32] = _createElementVNode("dt", { class: "text-gray-500" }, "Commentaires", -1)),
                              _createElementVNode("dd", _hoisted_42, _toDisplayString(details.value.commentaires), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (modalVisible.value = false))
                  }, " Fermer ")
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})